import React, {FC, useContext, useEffect, useState, useRef, RefObject } from 'react';
import {Context} from '../..';
import {Outlet, useLocation} from 'react-router-dom';
import '../../App.scss'
import {observer} from 'mobx-react-lite';
import {Header} from './Header';
import UserMenu from './menu/UserMenu';

type OverflowY = 'auto' | 'scroll' | 'hidden' | 'visible' | 'inherit' | 'initial' | 'unset';
export const LayoutMain: FC = observer(({ children }) => {
  const { store } = useContext(Context);
  const location = useLocation();
  const [headerRowHeight, setHeaderRowHeight] = useState<number>(0)
  const [overflowY, setOverflowY] = useState<OverflowY>('auto')
  const [headerOverflowY, setHeaderOverflowY] = useState<OverflowY>('auto')
  const headerRowRef: RefObject<HTMLDivElement> = useRef(null)
  // new ResizeObserver(onBodyResize).observe(document.querySelector('body'))
  useEffect(() => {
    store.setRef(location.pathname);
    if (['/answer-question', '/professions-atlas', '/alumni_videos', '/'].includes(location.pathname) && window.innerWidth > 480) {
      setOverflowY('hidden')
    } else {
      setOverflowY('auto')
    }
    if (headerRowRef !== null && headerRowRef.current) {
      setHeaderRowHeight(headerRowRef.current["clientHeight"])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, headerRowRef, window]);

  useEffect(() => {
    if (window.innerWidth > 480) {
      setHeaderOverflowY('hidden')
    } else {
      setHeaderOverflowY('auto')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window]);

  return (
    <div className="container-fluid" style={{height: window.innerHeight, overflowY: headerOverflowY}}>
      <div className='row header-row pt-4 pb-3' ref={headerRowRef}>
        <Header />
        {/* <TopMenu /> */}
      </div>
      <div className='row body-row' style={{height: window.innerHeight - headerRowHeight, overflowY: overflowY}}>
        <div className="col-md-2 user-menu">
          <UserMenu />
        </div>
        <div className='col-md-10 p-0'>
          <main className="w-100 h-100">{children}</main>
        </div>
        <Outlet />
      </div>
    </div>
  );
});

export const LayoutBlank: FC = ({ children }) => {
  const { store } = useContext(Context);
  const location = useLocation();

  useEffect(() => {
    store.setRef(location.pathname)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div className="container-fluid main-container">
      <div className='row'>
        <div className='col-12 col-md-12' >
          <main>{children}</main>
        </div>
        <Outlet />
      </div>
    </div>
  );
};